import React from 'react';
import { errorMessage } from '../config/constants';
import browser from '../helpers/browser';
import BrowserNotSupported from '../components/elements/BrowserNotSupported';
import SecondaryProductWarning from '../components/elements/SecondaryProductWarning';
import h from '../helpers/common';
import { useSelector } from 'react-redux';
import { Error, Button } from '@intigral/shared';
import { __ } from '../translations';

const ErrorPage = (props) => {
    const rebranding = h.getMigrationData();
    const isSecondaryProduct = useSelector((state) => state.user.secondaryProduct);

    /**
     * For login error please check: props.loginError === true
     */
    return (
        <Error
            icon="exclamation-mark"
            iconColor="red"
            errorPairs={
                h.getLang() === 'ar'
                    ? [{ title: 'Ooops..', text: errorMessage.MSG_AR }]
                    : [{ title: 'Ooops..', text: errorMessage.MSG_EN }]
            }
        >
            {props?.errorCtaHandler && (
                <Button
                    compact
                    LinkComponent="a"
                    href={h.getLang() === 'en' ? '/en' : '/'}
                    onClick={props.errorCtaHandler}
                >
                    {__('refresh_page')}
                </Button>
            )}
            {!browser.isSupported() ? <BrowserNotSupported /> : ''}
            {isSecondaryProduct && rebranding.enableMigrationBanner ? (
                <SecondaryProductWarning rebranding={rebranding} />
            ) : (
                ''
            )}
        </Error>
    );
};

export default ErrorPage;
